import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { logger } from "@/lib/logger";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1/sentinel`;

export default function useDashboardData() {
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastRefresh, setLastRefresh] = useState(null);
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [ipLog, setIpLog] = useState([]);
  const [pipelineStatus, setPipelineStatus] = useState(null);

  const fetchMetrics = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/dashboard/metrics`);
      setMetrics(res.data);
      setError(null);
      setLastRefresh(new Date());
    } catch (err) {
      setError(err.response?.status ? `HTTP ${err.response.status}` : err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchIpLog = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/ops/ip-log`);
      setIpLog(res.data.ips || []);
    } catch (err) {
      logger.warn("[Dashboard] IP log fetch:", err.message);
    }
  }, []);

  const fetchPipelineStatus = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/pipeline/status`);
      setPipelineStatus(res.data);
    } catch (err) {
      logger.debug("[Dashboard] Pipeline status:", err.message);
    }
  }, []);

  const toggleAutoRefresh = useCallback(() => {
    setAutoRefresh((v) => !v);
  }, []);

  // Initial metrics fetch
  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  // Auto-refresh metrics
  useEffect(() => {
    if (!autoRefresh) return;
    const interval = setInterval(fetchMetrics, 5000);
    return () => clearInterval(interval);
  }, [autoRefresh, fetchMetrics]);

  return {
    metrics,
    loading,
    error,
    lastRefresh,
    autoRefresh,
    toggleAutoRefresh,
    ipLog,
    pipelineStatus,
    fetchMetrics,
    fetchIpLog,
    fetchPipelineStatus,
  };
}
